module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAMAAACf4xmcAAAALVBMVEXNzc3CwsLHx8fCwsLNzc3Hx8fNzc3Nzc3Nzc3Nzc2/v7/Nzc0AAADKysrNzc2v+MiDAAAADXRSTlNt5L3jbryRE0gE/igAey2fxQAAAGpJREFUeNrt0jsOwCAMA1BaPkmg9P7HZbKgQ6yOlYrnJ0GchOtVNtvsV+y8H8kOa31VvXmPlpUV929Sp6rij5AmS2RSO6CisUIUTHlvGWVw1jrK4FsoKIMzqSiD7zSgDM4sRmMMUf3gWZIMUlhDsPZ7IBIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/img/jquery.datatables/sort_desc_disabled@2x.png
// module id = ../../../../../src/assets/img/jquery.datatables/sort_desc_disabled@2x.png
// module chunks = 2